import { render, staticRenderFns } from "./TabUser.vue?vue&type=template&id=3636ef7e&scoped=true&"
import script from "./TabUser.vue?vue&type=script&lang=ts&"
export * from "./TabUser.vue?vue&type=script&lang=ts&"
import style0 from "./TabUser.vue?vue&type=style&index=0&id=3636ef7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3636ef7e",
  null
  
)

export default component.exports